/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import './AllocationChart.scss';

import { forEach } from 'lodash';
import { object, string } from 'prop-types';
import React from 'react';

import { AllocationChartBar } from 'components/charts/Allocation/AllocationChartBar';

export default class AllocationChart extends React.Component {
  constructor(props) {
    super(props);

    this.chartBarClasses = this.chartBarClasses.bind(this);
  }

  chartBarClasses(type) {
    return {
      bar: `allocation-chart-${type}-bar`,
      heading: `allocation-chart-${type}-heading`,
      values: `allocation-chart-${type}-values`
    };
  }

  render() {
    const { allocations, fixedWidth } = this.props;

    const configs = [];
    forEach(allocations, (allocation, key) => {
      // calculate bar width based on percentage
      let barWidth = Math.round(Math.abs(allocation.percent) * 100);
      // adjust for minimum width or if allocation percentage is really small (rounded to zero) but there is an aggregate value
      if (
        (barWidth > 0 && barWidth < 23) ||
        (allocation.aggregate > 0 && barWidth === 0)
      ) {
        barWidth = 23;
      }
      // small margin when more than one config
      const barMargin = configs.length > 0 ? 1 : 0;
      if (barWidth > 0) {
        configs.push({
          allocation,
          barClasses: this.chartBarClasses(key.toLowerCase()),
          barWidth,
          barStyle: {
            width: `${barWidth}%`,
            marginLeft: `${barMargin}%`
          }
        });
      }
    });

    const chartStyle = {};
    if (fixedWidth) {
      chartStyle.width = fixedWidth;
    }

    return (
      <div className="allocation-chart" style={chartStyle}>
        {configs.map((config) => (
          <AllocationChartBar
            allocation={config.allocation}
            barClass={config.barClasses.bar}
            barStyle={config.barStyle}
            headingClass={config.barClasses.heading}
            key={config.allocation.label}
            valuesClass={config.barClasses.values}
          />
        ))}
      </div>
    );
  }
}

AllocationChart.propTypes = {
  allocations: object,
  fixedWidth: string
};

AllocationChart.defaultProps = {
  allocations: {},
  fixedWidth: null
};
